export const Images = {
  AVATAR_IMG: require("../assets/images/avatar_default.jpg"),
  LOGIN_BG_IMG: require("../assets/images/login_bg.jpg"),
  LOGO: require("../assets/images/logo.png"),
  LOGIN_COVER: require("../assets/images/login_cover.svg").default,
  NO_IMAGE: require("../assets/images/no_image.jpeg"),
  VERIFY_ICON: require("../assets/images/verify_icon.png"),
  TICK_ICON: require("../assets/images/tick_icon.png"),
};
